import { renderElement } from "../../utils/use-render.js";
import { useMenuContext } from "./context.js";
import { forwardRef } from "react";
//#region src/ui/menu/separator.tsx
/** Visual divider between groups of items. Renders a `<div>` with `role="separator"`. */
const MenuSeparator = forwardRef(function MenuSeparator({ render, className, style, ...elementProps }, forwardedRef) {
	const { state } = useMenuContext();
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		ref: [forwardedRef],
		props: [{ role: "separator" }, elementProps]
	});
});
//#endregion
export { MenuSeparator };

//# sourceMappingURL=separator.js.map